import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedReimaginedSyfIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [dataSourceInfo, employerContributions] = await Promise.all([
      this.reimaginedData.getDataSourceInfo(),
      this.reimaginedData.fetchEmployerContributions(),
    ]);

    return {
      dataSourceInfo,
      employerContributions,
    };
  }
}
